import { create } from 'zustand'

interface UIState {
  isLocked: boolean
  highlightColor: string | null
  setLocked: (locked: boolean) => void
  setHighlightColor: (color: string | null) => void
  toggleHighlightColor: (color: string) => void
}

export const useUIStore = create<UIState>((set) => ({
  isLocked: false,
  highlightColor: null,
  setLocked: (locked) => set({ isLocked: locked }),
  setHighlightColor: (color) => set({ highlightColor: color }),
  toggleHighlightColor: (color) =>
    set((state) => ({
      highlightColor: state.highlightColor === color ? null : color
    }))
}))
